var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('Menu'),_c('h2',{staticClass:"rubric-title"},[_vm._v("PRISE DE PAROLE EN PUBLIC")]),_c('ContentsPage',{attrs:{"contents-list":_vm.contentsSpeech}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }